import { AdminLayout, TableLayout } from "#layouts";
import React, { useEffect, useState } from "react";
import CustomAlert from "../../components/CustomAlert copy";
import {
  AlertTost,
  CustomInput,
  CustomModal,
  CustomTable,
  FilterBar,
  RowAction,
} from "#components";
import Swal from "sweetalert2";
import { cropTableHeader } from "#utils/seeds.js";
import { AdminRoutePath } from "#routes/routePath.jsx";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import useDelete from "#hooks/useDelete.js";
import usePost from "#hooks/usePost.js";
import usePut from "#hooks/usePut.js";
import useGet from "#hooks/useGet.js";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { cropInitialValues } from "#validations/initialValues.js";
import { cropValidationSchema } from "#validations/validationSchema.js";
import toast from "react-hot-toast";

const CropManagement = () => {
  const navigation = useNavigate();
  const [dataCount, setDataCount] = useState(10);
  const [searchInput, setSearchInput] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [cropDetails, setCropDetails] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [statusLoadingId, setStatusLoadingId] = useState(null);

  const [open, setOpen] = useState({
    add: false,
    edit: false,
  });

  const onOpen = (key, data) => {
    setOpen({ ...open, [key]: true });
    setCropDetails(data);
  };

  const onClose = (key) => {
    setOpen({
      ...open,
      [key]: false,
    });
    setCropDetails(null);
    resetForm();
  };

  const {
    data: cropListData,
    isLoading: isCropLoading,
    refetch: refetchCropList,
  } = useGet(ENDPOINTS.CROP_LISTING, QUERY_KEYS.CROP_LISTING_QUERY_KEY, {
    page: currentPage.toString(),
    limit: dataCount,
    search: searchInput,
  });

  const { mutateAsync: editCropMutateAsync, isLoading: isLoadingEditCrop } =
    usePut(ENDPOINTS.CROP_EDIT, QUERY_KEYS.CROP_EDIT_QUERY_KEY);

  const { mutateAsync: statusCropMutateAsync, isLoading: isLoadingStatusCrop } =
    usePut(ENDPOINTS.CROP_STATUS, QUERY_KEYS.CROP_STATUS_QUERY_KEY);
  const { mutateAsync: addCropMutateAsync, isLoading: isLoadingAddCrop } =
    usePost(ENDPOINTS.ADD_CROP, QUERY_KEYS.ADD_CROP_QUERY_KEY);

  const { mutateAsync: deleteCropMutateAsync } = useDelete(
    ENDPOINTS.CROP_DELETE,
    QUERY_KEYS.CROP_DELETE_QUERY_KEY
  );

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    resetForm,
  } = useFormik({
    initialValues: cropInitialValues,
    validationSchema: cropValidationSchema,
    onSubmit: async (values) => {
      try {
        const data = {
          cropId: cropDetails?._id,
          name: values.name,
        };
        if (open.add) {
          try {
            const response = await addCropMutateAsync(data);
            AlertTost(response?.message, "success");
            resetForm();
            onClose("add");
            refetchCropList();
          } catch (error) {
            toast.dismiss();
            AlertTost(error?.response?.data?.message, "error");
          }
        } else {
          try {
            const response = await editCropMutateAsync(data);
            AlertTost(response?.message, "success");
            resetForm();
            onClose("edit");
            refetchCropList();
          } catch (error) {
            toast.dismiss();
            AlertTost(error?.response?.data?.message, "error");
          }
        }
      } catch (error) {
        AlertTost("Something went wrong", "error");
      }
    },
  });
  useEffect(() => {
    if (open.edit) {
      setValues({
        name: cropDetails?.name,
      });
    }
    if (searchInput === "") {
      refetchCropList();
    }
  }, [open.edit, searchInput]);

  // Handle count input change
  const onDataCountChange = (e) => {
    setDataCount(e.target.value);
    setCurrentPage(1);
  };

  //onSearch button
  const onSearchButtonClick = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    refetchCropList();
  };

  //onSearch Change
  const onSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  useEffect(() => {
    refetchCropList();
  }, [dataCount, currentPage]);

  const handleDeleteCrop = async (cropId) => {
    CustomAlert({
      title: " Are you sure you  want to delete the crop?",
      confirmButtonText: "Confirm",
      icon: "question",
      onConfirm: async () => {
        try {
          await deleteCropMutateAsync({
            cropId: cropId,
          }).then((response) => {
            AlertTost(response?.message, "success");
            refetchCropList();
          });
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: error?.response?.data?.message,
            icon: "error",
            timer: 2000,
            showConfirmButton: false,
          });
        }
      },
    });
  };

  const handleStatusOnChange = async (item) => {
    try {
      setStatusLoadingId(item._id); // Track which row is loading
      await statusCropMutateAsync({
        cropId: item?._id,
      });
      await refetchCropList(); // Refresh the crop list after status update
    } catch (error) {
      console.error("Error updating crop status:", error);
      // Optionally show a toast or UI error message
    } finally {
      setStatusLoadingId(null); // Clear loading state
    }
  };

  // Pagination function
  const handelPageChange = (action) => {
    setCurrentPage((prevPage) => prevPage + (action === "prev" ? -1 : 1));
  };

  // drag and drop

  const handleDragOver = (e) => {
    e.preventDefault();
    if (!dragging) setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      setFieldValue("agronomistFile", droppedFile);
    }
  };

  const handleFileSelect = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFieldValue("agronomistFile", selectedFile);
    }
  };

  const handleRemoveFile = () => {
    setFieldValue("agronomistFile", null);
  };
  return (
    <AdminLayout>
      <section className="main-section spacer">
        <div className="container">
          {/* <FilterBar /> */}
          <FilterBar
            onSearchButtonClick={onSearchButtonClick}
            onSearchChange={onSearchChange}
            searchInput={searchInput}
            onChange={onDataCountChange}
            rowLimit={dataCount}
          />
          <div className="table_wrapper_card">
            <div className="row gy-3">
              <div className="col-xl-12">
                <div className="sub-heading flex-box">
                  <h2> Crop Listing </h2>
                  <div className="side-content-blk">
                    <button
                      onClick={() => onOpen("add")}
                      className="primary-btn"
                    >
                      Add New Crop
                    </button>
                  </div>
                </div>

                <TableLayout
                  tableHeader={cropTableHeader}
                  isEmpty={cropListData?.data?.list?.length === 0}
                  isLoading={isCropLoading}
                  currentPage={currentPage}
                  totalItems={cropListData?.data?.totalItems}
                  onDataCountChange={onDataCountChange}
                  handlePrevPage={() => handelPageChange("prev")}
                  handleNextPage={() => handelPageChange("next")}
                  rowLimit={dataCount}
                >
                  <CustomTable tableHeader={cropTableHeader}>
                    {cropListData?.data?.list.map((item, index) => {
                      return (
                        <tr key={index} className="cursor-pointer">
                          <td>{item?.name}</td>

                          <td>
                            <span
                              className={`table-status ${
                                item?.status === "Active"
                                  ? "st-active"
                                  : "st-suspended"
                              }`}
                            >
                              {item?.status === "Active"
                                ? "Active"
                                : "Inactive"}
                            </span>
                          </td>
                          <RowAction
                            activeAction={{
                              edit: true,
                              view: false,
                              delete: true,
                              status: true,
                            }}
                            onEdit={() => onOpen("edit", item)}
                            onDelete={() => handleDeleteCrop(item._id)}
                            onStatus={handleStatusOnChange}
                            isLoading={statusLoadingId === item._id}
                            item={item}
                          />
                        </tr>
                      );
                    })}
                  </CustomTable>
                </TableLayout>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*  Crop modal */}
      <CustomModal
        open={open.add || open.edit}
        title={open.add ? "Add New Crop" : "Edit Crop"}
        actionButtonTitle="Submit"
        onClose={() => onClose(open.add ? "add" : "edit")}
        onSubmit={handleSubmit}
        loading={isLoadingAddCrop || isLoadingEditCrop}
      >
        <div className="common-modal-form">
          <div className="row gy-4">
            {/* <div className="col-12">
              <div className="mdl_sub_heading mb-3">
                <h2 className="mb-0 fs-6 fw-medium">Upload CSV</h2>
              </div>
              <div
                className="upload_file_wrapper"
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <input
                  type="file"
                  className="d-none"
                  id="fileUpload"
                  onChange={handleFileSelect}
                />
                <label htmlFor="fileUpload">
                  <span className="file_icon">
                    <img src="/assets/images/icon/file-icon.svg" alt="file" />
                  </span>
                  <span>Drag or drop here</span>
                  <span>or</span>
                  <span className="primary_text">Browse</span>
                </label>
              </div>

              {values.agronomistFile && (
                <div className="file_preview">
                  <span className="file_name">
                    {values.agronomistFile.name}
                  </span>
                  <button className="remove_file" onClick={handleRemoveFile}>
                    x
                  </button>
                </div>
              )}
            </div>
            <div className="col-12">
              <div className="text_divider text-center text-uppercase">or</div>
            </div> */}
            <div className="col-lg-12">
              <CustomInput
                label="Crop name"
                type="text"
                name="name"
                placeholder="Enter crop name"
                value={values?.name}
                error={errors?.name}
                touched={touched?.name}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </AdminLayout>
  );
};

export default CropManagement;
